import { render, staticRenderFns } from "./safehaven-collapsible-list.vue?vue&type=template&id=528a872a&scoped=true&"
import script from "./safehaven-collapsible-list.vue?vue&type=script&lang=js&"
export * from "./safehaven-collapsible-list.vue?vue&type=script&lang=js&"
import style0 from "./safehaven-collapsible-list.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./safehaven-collapsible-list.vue?vue&type=style&index=1&id=528a872a&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "528a872a",
  null
  
)

export default component.exports